// extracted by mini-css-extract-plugin
export default {"Education":"Education_Education__BsOk+","Education__showcase":"Education_Education__showcase__S1+Qk"};